<template>
    <div class="kraken-footer-wrapper">
        <a href="mailto:hola@krakenlabsweb.com" class="kraken-footer-email">hola@krakenlabsweb.com</a>
        <p class="kraken-footer-ending-desc">Kraken Labs, desarrollos web ideados para entrar en la mente de tus clientes, contacta y consigue ahora una web única que te hará difereciarte de la competencia.</p>
        <ul class="kraken-footer-ending-menu1">
            <li><router-link to="/privacy">Política de privacidad</router-link></li>
        </ul>
        <ul class="kraken-footer-ending-menu2">
            <li><router-link to="/">Inicio</router-link></li>
            <li><router-link to="/services">Servicios</router-link></li>
            <li><router-link to="/#homeProjectsList">Proyectos</router-link></li>
            <li><router-link to="/about">Sobre Kraken Labs</router-link></li>
            <li><a href="https://blog.krakenlabsweb.com">Blog</a></li>
            <li><router-link to="/contact">Contacto</router-link></li>
        </ul>

        <ul class="kraken-footer-ending-social">
            <li><a target="_blank" rel="nofollow noreferrer noopener" href="https://www.facebook.com/KrakenLabsWeb">FA</a></li>
            <li><a target="_blank" rel="nofollow noreferrer noopener" href="https://www.instagram.com/krakenkabsweb">IN</a></li>
            <li><a target="_blank" rel="nofollow noreferrer noopener" href="https://www.linkedin.com/in/chemaalfonso/">LK</a></li>
            <li><a target="_blank" rel="nofollow noreferrer noopener" href="https://github.com/ChemaAlfonso">GH</a></li>
        </ul>

        <span class="kraken-footer-copy">&copy; 2020 Kraken Labs <small>By <a target="_blank" rel="noopener" href="https://chemaalfonso.com">Chema Alfonso</a></small></span>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'

    export default Vue.extend({
        name: 'Footer'
    })
</script>

<style scoped lang="scss">
    .kraken-footer {
        &-wrapper {
            color: #fff;
            min-height: 800px;
            display: grid;
            grid-template-columns: repeat(12, 1fr);
            grid-template-rows: 55% 15% 20% 5% 5%;
            padding-bottom: 5rem;
            grid-gap: 1rem;
        }

        &-email {
            grid-column: 2 / span 10;
            grid-row: 1;
            display: flex;
            align-items: center;
            font-size: 2.5rem;
            color: #8B8B8B;
            text-decoration: none;
            transition: all .25s;
            border-bottom: 1px solid #fff;
            word-break: break-all;

            &:hover {
                color: #fff;
            }
        }

        &-ending {
            &-desc {
                grid-column: 2 / span 10;
                grid-row: 2;
                text-align: justify;
            }

            &-menu1 {
                display: block;
                list-style: none;
                grid-column: 7 / span 6;
                grid-row: 3;

                & li {
                    margin-bottom: .6rem;
                }

                & a {
                    color: #fff;
                    text-decoration: none;
                    transition: all .25s;

                    &:hover {
                        color:  rgb(230, 172, 49);
                    }
                }
            }

            &-menu2 {
                display: block;
                list-style: none;
                grid-column: 2 / span 6;
                grid-row: 3;

                & li {
                    margin-bottom: .6rem;
                }

                & a {
                    color: #fff;
                    text-decoration: none;
                    transition: all .25s;

                    &:hover {
                        color:  rgb(230, 172, 49);
                    }
                }
            }

            &-social {
                display: flex;
                list-style: none;
                grid-column: 1 / span 12;
                grid-row: 4;
                justify-content: center;

                & li {
                    border: 1px solid #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    cursor: pointer;
                    user-select: none;
                    transition: all .3s;
                    margin-right: .5rem;

                    & a {
                        color: #fff;
                        text-decoration: none;
                    }

                    &:hover {
                        background-color: #fff;
                        border: 1px solid #121315;
                        & a {
                            color: #121315;
                            text-decoration: none;
                        }
                    }
                }

                @media SCREEN AND ( min-width: 1200px ) {
                    & li {
                        width: 60px;
                        height: 60px;
                    }
                }
            }
        }

        &-copy {
            display: flex;
            align-items: flex-end;
            justify-content: center;
            color: #8B8B8B;
            grid-column: span 12;
            grid-row: 5;

            & a {
                color: #8B8B8B;
                text-decoration: none;
            }

            & small {
                margin-left: .6rem;
                font-size: .6rem;
                padding-bottom: .2rem;            
            }
        }

    }
    

    @media SCREEN AND ( min-width: 768px ) {
        .kraken-footer {
            &-wrapper {
                color: #fff;
                min-height: 800px;
                display: grid;
                grid-template-columns: repeat(12, 1fr);
                grid-template-rows: 70% 20% 10%;
                grid-gap: 2rem;
                padding-bottom: 5rem;
            } 

            &-email {
                font-size: 3.5rem;
            }

            &-ending { 

                &-desc {
                    grid-column: 2 / span 2;
                    grid-row: 2;
                }
                

                &-menu1 {
                    grid-column: 6 / span 2;
                    grid-row: 2;
                }

                &-menu2 {
                    grid-column: 4 / span 2;
                    grid-row: 2;
                }

                &-social {
                    grid-column: 8 / span 4;
                    grid-row: 2;
                }
            }

            &-copy {
                justify-content: flex-end;
                grid-column: span 11;
                grid-row: 3;
            }

        }
    }
</style>